module.exports = __webpack_public_path__ + "img/Joerg-Wienbreyer.5b023525.webp";